/** Merge the latest server snapshot with only fields edited locally. */
export function mergeDirty<T extends object>(server: T, dirty: Partial<T>): T {
  return { ...server, ...dirty }
}

/** Empty form values explicitly clear an override; an untouched field stays absent. */
export function nullableOverride(value: string | undefined): string | null | undefined {
  if (value === undefined) return undefined
  return value === '' ? null : value
}
